"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const urlJoin_1 = require("./urlJoin");
function urlJoin(baseUrl, ...paths) {
    return new urlJoin_1.UrlJoin(baseUrl, paths).toString();
}
exports.urlJoin = urlJoin;
function urlJoinP(baseUrl, paths, params = {}) {
    return new urlJoin_1.UrlJoin(baseUrl, paths).queryParams(params).toString();
}
exports.urlJoinP = urlJoinP;
